import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Textarea } from '../ui/textarea';
import { Badge } from '../ui/badge';
import { Trash2, BookOpen, ChevronUp, ChevronDown, Bold, Info, Heading } from 'lucide-react';

/** Singola riga voce documento: codice articolo con ricerca, descrizione, qta, prezzi. */
export const VoceRiga = ({
  voce, index, searchValue, results,
  onSearchChange, onCodiceKeyDown, onSelectArticolo, onUpdate, onRemove, onMove, count, onApriCatalogo, removable,
}) => {
  const totaleRiga = (
    (parseFloat(voce.prezzo_unitario) || 0) *
    (parseFloat(voce.quantita) || 1) *
    (1 - (parseFloat(voce.sconto_percentuale) || 0) / 100)
  ).toFixed(2);

  return (
    <div className="border border-border p-3 space-y-2">
      <div className="flex items-center justify-between -mb-1">
        <span className="text-[10px] font-mono uppercase text-muted-foreground flex items-center gap-2">
          Voce {index + 1}
          {voce.is_titolo && (
            <span className="text-sky-600 normal-case font-sans" data-testid={`voce-titolo-label-${index}`}>
              titolo di sezione — senza prezzo
            </span>
          )}
          {!voce.is_titolo && voce.escludi_totale && (
            <span className="text-amber-600 normal-case font-sans" data-testid={`voce-info-label-${index}`}>
              prezzo informativo — non sommato al totale
            </span>
          )}
        </span>
        <div className="flex gap-1">
          <Button
            type="button"
            size="icon"
            variant={voce.is_titolo ? 'default' : 'ghost'}
            className={`h-6 w-6 rounded-none ${voce.is_titolo ? 'bg-sky-600 hover:bg-sky-700' : ''}`}
            onClick={() => onUpdate(index, 'is_titolo', !voce.is_titolo)}
            title={voce.is_titolo ? 'Titolo di sezione (senza prezzo) — clicca per tornare a voce normale' : 'Trasforma in TITOLO DI SEZIONE: solo testo, senza prezzi (es: HARDWARE / SERVIZI)'}
            data-testid={`voce-titolo-${index}`}
          >
            <Heading className="h-3.5 w-3.5" />
          </Button>
          {!voce.is_titolo && (
          <Button
            type="button"
            size="icon"
            variant={voce.escludi_totale ? 'default' : 'ghost'}
            className={`h-6 w-6 rounded-none ${voce.escludi_totale ? 'bg-amber-500 hover:bg-amber-600' : ''}`}
            onClick={() => onUpdate(index, 'escludi_totale', !voce.escludi_totale)}
            title={voce.escludi_totale ? 'Prezzo SOLO INFORMATIVO (escluso dal totale) — clicca per includerlo di nuovo' : 'Escludi dal totale: il cliente vede il prezzo a titolo informativo ma NON viene sommato'}
            data-testid={`voce-escludi-${index}`}
          >
            <Info className="h-3.5 w-3.5" />
          </Button>
          )}
          {!voce.is_titolo && (
          <Button
            type="button"
            size="icon"
            variant={voce.evidenzia ? 'default' : 'ghost'}
            className="h-6 w-6 rounded-none"
            onClick={() => onUpdate(index, 'evidenzia', !voce.evidenzia)}
            title={voce.evidenzia ? 'Riga in grassetto sul PDF — clicca per togliere' : 'Metti la riga in grassetto sul PDF (per evidenziarla)'}
            data-testid={`voce-bold-${index}`}
          >
            <Bold className="h-3.5 w-3.5" />
          </Button>
          )}
          <Button
            type="button"
            size="icon"
            variant="ghost"
            className="h-6 w-6 rounded-none"
            onClick={() => onMove(index, -1)}
            disabled={index === 0}
            title="Sposta in su"
            data-testid={`voce-su-${index}`}
          >
            <ChevronUp className="h-4 w-4" />
          </Button>
          <Button
            type="button"
            size="icon"
            variant="ghost"
            className="h-6 w-6 rounded-none"
            onClick={() => onMove(index, 1)}
            disabled={index === count - 1}
            title="Sposta in giù"
            data-testid={`voce-giu-${index}`}
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </div>
      </div>
      {voce.is_titolo ? (
        <div className="grid grid-cols-12 gap-2 items-end">
          <div className="col-span-9 md:col-span-10">
            <Label className="text-xs text-muted-foreground">
              Titolo sezione
              <span className="text-muted-foreground/60 ml-1">(banda evidenziata sul PDF, senza colonne prezzo)</span>
            </Label>
            <Input
              value={voce.descrizione}
              onChange={(e) => onUpdate(index, 'descrizione', e.target.value)}
              className="rounded-none font-bold uppercase tracking-wide"
              placeholder="ES: HARDWARE / SERVIZI / CANONE ANNUALE"
              required
              data-testid={`voce-descrizione-${index}`}
            />
          </div>
          <div className="col-span-3 md:col-span-2">
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => onRemove(index)}
              disabled={!removable}
              className="rounded-none w-full h-10 text-destructive hover:bg-destructive hover:text-destructive-foreground"
            >
              <Trash2 className="h-4 w-4 mr-1" />
              Rimuovi
            </Button>
          </div>
        </div>
      ) : (
      <>
      <div className="grid grid-cols-12 gap-2 items-end">
        <div className="col-span-12 md:col-span-2 relative">
          <Label className="text-xs text-muted-foreground">Codice Articolo</Label>
          <div className="flex gap-1">
            <Input
              value={searchValue ?? (voce.codice_listino || '')}
              onChange={(e) => onSearchChange(index, e.target.value)}
              onKeyDown={(e) => onCodiceKeyDown(index, e)}
              className="rounded-none font-mono text-sm flex-1 min-w-0"
              placeholder="Cerca o scansiona..."
              data-testid={`voce-codice-${index}`}
            />
            <Button
              type="button"
              size="icon"
              variant="outline"
              className="rounded-none shrink-0 border-primary text-primary"
              onClick={() => onApriCatalogo(index)}
              title="Sfoglia tutto il listino"
              data-testid={`voce-sfoglia-${index}`}
            >
              <BookOpen className="h-4 w-4" />
            </Button>
          </div>
          {results?.length > 0 && (
            <div className="absolute z-50 w-80 mt-1 bg-background border-2 border-primary shadow-lg max-h-48 overflow-y-auto">
              <div className="p-2 bg-muted text-xs font-mono uppercase text-muted-foreground">
                Seleziona articolo:
              </div>
              {results.map((art) => (
                <div
                  key={`${art.fonte || 'listino'}-${art.id}`}
                  className="p-2 hover:bg-primary hover:text-primary-foreground cursor-pointer border-b border-border last:border-b-0 transition-colors"
                  onClick={() => onSelectArticolo(index, art)}
                  data-testid={`risultato-articolo-${art.id}`}
                >
                  <div className="flex justify-between items-center gap-2">
                    <span className="font-mono font-bold">{art.codice}</span>
                    {art.fonte === 'magazzino' && (
                      <Badge variant="outline" className="text-[9px] uppercase text-violet-600 border-violet-500 shrink-0">Magazzino{typeof art.quantita === 'number' ? ` · ${art.quantita} pz` : ''}</Badge>
                    )}
                    <span className="font-bold text-green-600 ml-auto">€{art.prezzo?.toFixed(2)}</span>
                  </div>
                  <p className="text-xs opacity-70">{art.descrizione}</p>
                  {art.matricola && (
                    <p className="text-[10px] font-mono opacity-60">Matr. {art.matricola}</p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="col-span-12 md:col-span-10">
          <Label className="text-xs text-muted-foreground">
            Descrizione
            <span className="text-muted-foreground/60 ml-1">(puoi modificare e aggiungere matricola, dettagli, ecc.)</span>
          </Label>
          <Textarea
            value={voce.descrizione}
            onChange={(e) => onUpdate(index, 'descrizione', e.target.value)}
            className={`rounded-none min-h-[60px] resize-none ${voce.evidenzia ? 'font-bold' : ''}`}
            placeholder="Descrizione articolo... Aggiungi matricola, S/N, specifiche tecniche..."
            required
            data-testid={`voce-descrizione-${index}`}
          />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-2 items-end">
        <div className="col-span-3 md:col-span-2">
          <Label className="text-xs text-muted-foreground">Qtà</Label>
          <Input
            type="number"
            step="0.01"
            value={voce.quantita}
            onChange={(e) => onUpdate(index, 'quantita', e.target.value)}
            className="rounded-none"
            data-testid={`voce-quantita-${index}`}
          />
        </div>
        <div className="col-span-3 md:col-span-2">
          <Label className="text-xs text-muted-foreground">U.M.</Label>
          <Select value={voce.unita_misura || 'pz'} onValueChange={(v) => onUpdate(index, 'unita_misura', v)}>
            <SelectTrigger className="rounded-none h-10">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="pz">pz</SelectItem>
              <SelectItem value="ore">ore</SelectItem>
              <SelectItem value="kg">kg</SelectItem>
              <SelectItem value="mt">mt</SelectItem>
              <SelectItem value="lt">lt</SelectItem>
              <SelectItem value="conf">conf</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="col-span-3 md:col-span-2">
          <Label className="text-xs text-muted-foreground">Prezzo Unit.</Label>
          <Input
            type="number"
            step="0.01"
            value={voce.prezzo_unitario}
            onChange={(e) => onUpdate(index, 'prezzo_unitario', e.target.value)}
            className="rounded-none font-mono"
            data-testid={`voce-prezzo-${index}`}
          />
        </div>
        <div className="col-span-3 md:col-span-2">
          <Label className="text-xs text-muted-foreground">Sconto %</Label>
          <Input
            type="number"
            step="1"
            max="100"
            value={voce.sconto_percentuale}
            onChange={(e) => onUpdate(index, 'sconto_percentuale', e.target.value)}
            className="rounded-none"
            data-testid={`voce-sconto-${index}`}
          />
        </div>
        <div className="col-span-6 md:col-span-2">
          <Label className="text-xs text-muted-foreground">Totale Riga</Label>
          <div className={`h-10 flex items-center px-3 bg-muted/50 border rounded-none font-mono font-bold ${voce.escludi_totale ? 'text-amber-600 line-through decoration-1' : 'text-emerald-600'}`} title={voce.escludi_totale ? 'Prezzo informativo: non sommato al totale documento' : undefined}>
            € {totaleRiga}{voce.escludi_totale ? ' *' : ''}
          </div>
        </div>
        <div className="col-span-6 md:col-span-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onRemove(index)}
            disabled={!removable}
            className="rounded-none w-full h-10 text-destructive hover:bg-destructive hover:text-destructive-foreground"
          >
            <Trash2 className="h-4 w-4 mr-1" />
            Rimuovi
          </Button>
        </div>
      </div>
      </>
      )}
    </div>
  );
};
